import { supabase } from "./supabase";
import { fromDbPersonnel, toDbPersonnelInsert } from "../lib/mappers";

const PERSONNEL_COLUMNS =
  "id, dpr_id, name, position, location_today, location_tomorrow, sort_order";

const listPersonnel = async (dprId) => {
  const { data, error } = await supabase
    .from("personnel_entries")
    .select(PERSONNEL_COLUMNS)
    .eq("dpr_id", dprId)
    .order("sort_order", { ascending: true });

  if (error) throw error;
  return (data ?? []).map(fromDbPersonnel);
};

const createPersonnel = async (entry) => {
  const payload = toDbPersonnelInsert(entry);
  const { data, error } = await supabase
    .from("personnel_entries")
    .insert(payload)
    .select(PERSONNEL_COLUMNS)
    .single();

  if (error) throw error;
  return fromDbPersonnel(data);
};

const updatePersonnel = async (id, entry) => {
  const { data, error } = await supabase
    .from("personnel_entries")
    .update({
      name: entry.name,
      position: entry.position,
      location_today: entry.locationToday || "",
      location_tomorrow: entry.locationTomorrow || "",
      sort_order: entry.sortOrder ?? 0,
    })
    .eq("id", id)
    .select(PERSONNEL_COLUMNS)
    .single();

  if (error) throw error;
  return fromDbPersonnel(data);
};

const deletePersonnel = async (id) => {
  const { error } = await supabase
    .from("personnel_entries")
    .delete()
    .eq("id", id);
  if (error) throw error;
};

const copyPersonnelFromPreviousDpr = async (currentDprId, previousDprId) => {
  const previous = await listPersonnel(previousDprId);
  if (!previous.length) return [];

  const payload = previous.map((p, i) =>
    toDbPersonnelInsert({
      dprId: currentDprId,
      name: p.name,
      position: p.position,
      locationToday: p.locationToday,
      locationTomorrow: p.locationTomorrow,
      sortOrder: i,
    })
  );

  const { data, error } = await supabase
    .from("personnel_entries")
    .insert(payload)
    .select(PERSONNEL_COLUMNS);

  if (error) throw error;
  return (data ?? []).map(fromDbPersonnel);
};

export {
  listPersonnel,
  createPersonnel,
  updatePersonnel,
  deletePersonnel,
  copyPersonnelFromPreviousDpr,
};
